// Клиент-обёртка над solver.worker.js (PlaneGCS).
//
// Использование:
//   const solver = getSolverClient();
//   await solver.init();
//   const result = await solver.solve(primitives, { draggingId, draggingX, draggingY });
//
// result = { primitives: [...], status, conflicts: string[], redundant: string[] }

export class SolverClient {
    constructor() {
        this.worker = null;
        this.ready = false;
        this._initResolve = null;
        this._initReject = null;
        this._solveResolve = null;
        this._solveReject = null;
    }

    init() {
        return new Promise((resolve, reject) => {
            try {
                this.worker = new Worker(
                    new URL('./workers/solver.worker.js', import.meta.url),
                    { type: 'module' }
                );
            } catch (e) {
                reject(e);
                return;
            }
            this.worker.onmessage = (e) => this._dispatch(e.data);
            this.worker.onerror = (e) => {
                console.error('[solver.worker] onerror', e);
                if (!this.ready && this._initReject) this._initReject(e);
            };
            this._initResolve = resolve;
            this._initReject = reject;
            this.worker.postMessage({ type: 'INIT' });
        });
    }

    _dispatch(msg) {
        switch (msg.type) {
            case 'KERNEL_READY':
                this.ready = true;
                if (this._initResolve) this._initResolve();
                break;
            case 'KERNEL_ERROR':
                if (this._initReject) this._initReject(new Error(msg.message));
                break;
            case 'SOLVED':
                if (this._solveResolve) {
                    this._solveResolve({
                        primitives: msg.primitives,
                        status: msg.status,
                        conflicts: msg.conflicts || [],
                        redundant: msg.redundant || [],
                        dof: (typeof msg.dof === 'number') ? msg.dof : null,
                        failed: !!msg.failed,
                    });
                    this._solveResolve = null;
                }
                break;
            case 'SOLVE_ERROR':
                if (this._solveReject) {
                    this._solveReject(new Error(msg.message));
                    this._solveReject = null;
                }
                break;
            default:
                console.warn('[solverClient] unknown msg type:', msg.type, msg);
        }
    }

    /**
     * @param primitives — массив SketchPrimitive в формате PlaneGCS
     * @param drag — { draggingId?, draggingX?, draggingY? } | null
     */
    solve(primitives, drag = null) {
        return new Promise((resolve, reject) => {
            this._solveResolve = resolve;
            this._solveReject = reject;
            this.worker.postMessage({
                type: 'SOLVE',
                payload: {
                    primitives,
                    draggingId: drag?.draggingId,
                    draggingX: drag?.draggingX,
                    draggingY: drag?.draggingY,
                },
            });
        });
    }

    destroy() {
        if (this.worker) {
            this.worker.terminate();
            this.worker = null;
            this.ready = false;
        }
    }
}


let _instance = null;
export function getSolverClient() {
    if (!_instance) _instance = new SolverClient();
    return _instance;
}
